exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.table-container table.table-layout[data-v-44d0c8b2]{width:100%;table-layout:fixed;border-collapse:collapse}\n", ""]);

// exports
